module.exports = "pegasus/assets/themelp1/small/52.png";